import AdditionalTextStep from "../components/AdditionalTextStep";
import AddressStep from "../components/AddressStep";
import BizPhoneNumberStep from "../components/BizPhoneNumberStep";
import CityStep from "../components/CityStep";
import ContactPhoneStep from "../components/ContactPhoneStep";
import DurationStep from "../components/DurationSelectionStep";
import EmailStep from "../components/EmailStep";
import FacebookStep from "../components/FacebookStep";
import FirstNameStep from "../components/FirstNameStep";
import InstagramStep from "../components/InstagramStep";
import LastNameStep from "../components/LastNameStep";
import LayoutStep from "../components/LayoutStep";
import OfferTextStep from "../components/OfferTextStep";
import OrderConfirmationStep from "../components/OrderConfirmationStep";
import PaymentInformationStep from "../components/PaymentInformationStep";
import PostalCodeStep from "../components/PostalCodeStep";
import RoleStep from "../components/RoleStep";
import StartDateStep from "../components/StartDateStep";
import StateStep from "../components/StateStep";
import TwitterStep from "../components/TwitterStep";
import WebsiteStep from "../components/WebsiteStep";
import BusinessStepContainer from "../containers/BusinessStep";
import CategoriesStepContainer from "../containers/CategoriesStep";
import WidgetStep from "../containers/WidgetSelectionStep";
import * as Paths from "./paths";

export default [
  {
    title: "Business Selection Step",
    path: Paths.BUSINESS_PATH,
    exact: true,
    strict: true,
    component: BusinessStepContainer,
    step: 1,
  },
  {
    title: "Subcategory Selection Step",
    path: Paths.SUB_CATEGORY_PATH,
    exact: true,
    strict: true,
    component: CategoriesStepContainer,
    step: 2,
  },
  {
    title: "First Name Step",
    path: Paths.FIRST_NAME_PATH,
    exact: true,
    strict: true,
    component: FirstNameStep,
    step: 3,
  },
  {
    title: "Last Name Step",
    path: Paths.LAST_NAME_PATH,
    exact: true,
    strict: true,
    component: LastNameStep,
    step: 4,
  },
  {
    title: "Role Step",
    path: Paths.ROLE_PATH,
    exact: true,
    strict: true,
    component: RoleStep,
    step: 5,
  },
  {
    title: "Contact Phone Step",
    path: Paths.CONTACT_PHONE_PATH,
    exact: true,
    strict: true,
    component: ContactPhoneStep,
    step: 6,
  },
  {
    title: "Layout Step",
    path: Paths.LAYOUT_PATH,
    exact: true,
    strict: true,
    component: LayoutStep,
    step: 7,
  },
  {
    title: "Offer Text Step",
    path: Paths.CAPTION_PATH,
    exact: true,
    strict: true,
    component: OfferTextStep,
    step: 8,
  },
  {
    title: "Address Step",
    path: Paths.ADDRESS_PATH,
    exact: true,
    strict: true,
    component: AddressStep,
    step: 9,
  },
  {
    title: "City Step",
    path: Paths.CITY_PATH,
    exact: true,
    strict: true,
    component: CityStep,
    step: 10,
  },
  {
    title: "State Step",
    path: Paths.STATE_PATH,
    exact: true,
    strict: true,
    component: StateStep,
    step: 11,
  },
  {
    title: "Zip Step",
    path: Paths.ZIP_PATH,
    exact: true,
    strict: true,
    component: PostalCodeStep,
    step: 12,
  },
  {
    title: "Business Phone Step",
    path: Paths.PHONE_PATH,
    exact: true,
    strict: true,
    component: BizPhoneNumberStep,
    step: 13,
  },
  {
    title: "Website Step",
    path: Paths.WEBSITE_PATH,
    exact: true,
    strict: true,
    component: WebsiteStep,
    step: 14,
  },
  {
    title: "Facebook Step",
    path: Paths.FACEBOOK_PATH,
    exact: true,
    strict: true,
    component: FacebookStep,
    step: 15,
  },
  {
    title: "Twitter Step",
    path: Paths.TWITTER_PATH,
    exact: true,
    strict: true,
    component: TwitterStep,
    step: 16,
  },
  {
    title: "Instagram Step",
    path: Paths.INSTAGRAM_PATH,
    exact: true,
    strict: true,
    component: InstagramStep,
    step: 17,
  },
  {
    title: "Additional Text Step",
    path: Paths.ADDITIONAL_TEXT_PATH,
    exact: true,
    strict: true,
    component: AdditionalTextStep,
    step: 18,
  },
  {
    title: "Email Step",
    path: Paths.EMAIL_PATH,
    exact: true,
    strict: true,
    component: EmailStep,
    step: 19,
  },
  {
    title: "Widget Selection Step",
    path: Paths.WIDGET_SELECTION_PATH,
    exact: true,
    strict: true,
    component: WidgetStep,
    step: 19,
  },
  {
    title: "Duration Step",
    path: Paths.DURATION_SELECTION_PATH,
    exact: true,
    strict: true,
    component: DurationStep,
    step: 20,
  },
  {
    title: "Start Date Step",
    path: Paths.START_DATE_SELECTION_PATH,
    exact: true,
    strict: true,
    component: StartDateStep,
    step: 21,
  },
  {
    title: "Payment Information Step",
    path: Paths.PAYMENT_INFORMATION_PATH,
    exact: true,
    strict: true,
    component: PaymentInformationStep,
    step: 22,
  },
  {
    title: "Order Confirmation Step",
    path: Paths.ORDER_CONFIRMATION_PATH,
    exact: true,
    strict: true,
    component: OrderConfirmationStep,
    step: 23,
  },
];
